import React from 'react';

import { useSelector } from 'react-redux';

import { useFeatures } from '@atc/features';

import { LazyRender } from 'reaxl';

import userAgentDuck from '@/ducks/userAgentDuck';

function LazyComponent({
    children,
    componentClass: Component = 'div',
    componentProps,
    height,
    fallback = null,
    threshold,
    width,
}) {
    const {
        lazy_component_threshold: [, { defaultThreshold, enableIdleRender }],
    } = useFeatures(['lazy_component_threshold']);
    const isAIBot = useSelector(userAgentDuck.selectors.isAIBot);

    return (
        <LazyRender
            fallback={fallback}
            componentClass={Component}
            componentProps={componentProps}
            threshold={threshold || defaultThreshold}
            height={height}
            width={width}
            enableIdleRender={enableIdleRender}
            forceRender={isAIBot}
        >
            {children}
        </LazyRender>
    );
}

export default LazyComponent;
